import React from 'react';
import { Redirect } from 'react-router-dom';

const Users = () => {
  return <Redirect to="/admin/users/clients" />;
};

export default Users;
